// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"lazysizes":"a603d24602b85b55f6bb","flickity":"6a3a67171ee894fb58c6","flickity-fade":"8b007ed4a47f674c2146"}[chunkId] + ".js";
};